import React from 'react';
import { RefreshCw } from 'react-feather';
import AuthenticateChildren from '../AuthenticateChildren';
import OptionsButton from '../components/OptionsButton';
import { roles } from '../constants';
import { DropdownItem } from 'reactstrap';
import { EVO } from '../EVO';
import AuthService from '../AuthService';
import { useEffect } from 'react';
import { useState } from 'react';
import { Loader } from '../components/Loader';


export const Home = props => {
    const [on, setOn] = useState(false);
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getStatus();
    }, []);

    const getStatus = () => {
        if (AuthService.getInstance().isAdmin()) {
            setStatus('');
            setLoading(true);
            EVO.get('/api/home/getstagingstatus').then(r => {
                setOn(r.isOn);
                setStatus(r.status);
                setLoading(false);
            }).catch(e => {
                EVO.alert('Error retrieving staging status');
                setLoading(false);
            });
        }
    };


    const bob = (onOff) => {
        EVO.post(onOff ? '/api/home/turnstagingon' : '/api/home/turnstagingoff').then(r => {
            EVO.success(`Successfully turned ${onOff ? 'on' : 'off'}`);
            getStatus();
        }).catch(e => {
            EVO.alert(`Error turning ${onOff ? 'on' : 'off'}`);
        });
    };

    return (
        <div>
            <h1>Hello!</h1>
            <p>Welcome to Peptalkr</p>
            <AuthenticateChildren roles={[roles.Admin]}>
                <Loader loading={loading}>
                    <span onClick={() => getStatus()}>Staging Status: {status}</span>
                    <OptionsButton>
                        {on ? <DropdownItem onClick={() => bob(false)}><RefreshCw /> Turn off Staging server</DropdownItem> :
                            <DropdownItem onClick={() => bob(true)}><RefreshCw /> Turn on Staging server</DropdownItem>
                        }
                    </OptionsButton>
                </Loader>
            </AuthenticateChildren>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/pages/Home.js